import React from "react";
import UpgradeFirmwareDialog from "./UpgradeFirmwareDialog";
import FirmwareUpgradeProgressDialog from "./FirmwareUpgradeProgressDialog";

interface EdgeFirmwareDialogsProps {
  open: boolean;
  firmwareVersion: any;
  edgeOta: any;
}

const EdgeFirmwareDialogs = ({
  open,
  firmwareVersion,
  edgeOta,
}: EdgeFirmwareDialogsProps) => {
  if (!open) {
    return null;
  }

  return (
    <>
      <UpgradeFirmwareDialog
        open={edgeOta.openUpgradeDialog}
        firmwareVersion={firmwareVersion}
        currentFirmwareCatalog={edgeOta.currentFirmwareCatalog}
        installedFirmwareVersion={edgeOta.installedFirmwareVersion}
        newerFirmwareVersions={edgeOta.newerFirmwareVersions}
        loadingFirmwareVersions={edgeOta.loadingFirmwareVersions}
        selectedUpgradeVersion={edgeOta.selectedUpgradeVersion}
        isUpgradingFirmware={edgeOta.isUpgradingFirmware}
        onClose={edgeOta.closeUpgradeDialog}
        onSelectVersion={edgeOta.setSelectedUpgradeVersion}
        onUpgrade={edgeOta.handleUpgradeFirmware}
      />
      <FirmwareUpgradeProgressDialog
        open={
          (edgeOta.isFirmwareUpdating && !edgeOta.progressDialogHidden) ||
          edgeOta.upgradeJustCompleted ||
          edgeOta.upgradeFailed
        }
        versionInfo={edgeOta.activeUpgradeVersionInfo}
        percent={edgeOta.progressPercent}
        secondsRemaining={edgeOta.secondsRemaining}
        stage={edgeOta.currentFwStage}
        completed={edgeOta.upgradeJustCompleted}
        failed={edgeOta.upgradeFailed}
        onClose={edgeOta.dismissFirmwareProgressDialog}
      />
    </>
  );
};

export default EdgeFirmwareDialogs;
